module.exports = __webpack_public_path__ + "static/media/notifications-follower.2a38745b.svg";